import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Activities from "../components/Activities";

const ActivitiesPage = () => {
  const { t } = useTranslation();
  const [activeSection, setActiveSection] = useState("activities");
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <Header
        activeSection={activeSection}
        setActiveSection={setActiveSection}
      />

      {/* Main Content */}
      <main className="pt-16">
        {/* Activities Section */}
        <Activities />
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default ActivitiesPage;
